function storiesDisplay(highlightList, hlstart, hlend){
	$.ajax({
		url: highlightList,
		dataType: 'json',
		async: false,
		data: { 'data' : 'data' },
		success: function(json) {
			let startDate = new Date(hlstart.substr(0,4),hlstart.substr(4,2)-1,hlstart.substr(6,2));
			let startDateTime = startDate.getTime();
			let endDate   = new Date(hlend.substr(0,4),hlend.substr(4,2)-1,hlend.substr(6,2));

			for (let d=startDate; d<=endDate; d.setDate(d.getDate()+1) ) {
				let workstr = d.getFullYear() + '-' + ('0' + (d.getMonth()+1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
				let dayOfWeek = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"][d.getDay()];
				let target = json.items.filter(function(v) { return v.datetime == workstr})[0];

				$li = $('<li>');
				if (target) {
					// データあり
					$a = $('<a>', {"class":"dateEvent", "id":workstr});
					if(dayOfWeek==="Sun"){
						$a.addClass("sun");
					} else if(dayOfWeek==="Sat"){
						$a.addClass("sat");
					}
					$spanMonth = $('<span>', {"class":"month", "text":d.getMonth()+1+'/'});
					$spanDate  = $('<span>', {"text":d.getDate()});
					$spanWeek  = $('<span>', {"class":"day", "text":dayOfWeek});

					if(d.getDate()===1 || d.getTime()==startDateTime){
						$(".specialContents .dateLists").append($li.append($a.append($spanMonth,$spanDate,$spanWeek)));
					}
					else{
						$(".specialContents .dateLists").append($li.append($a.append($spanDate,$spanWeek)));
					}
				}
				else {
					// 空リストを追加
					$span = $('<span>');
					if(dayOfWeek==="Sun"){
						$span.addClass("sun");
					} else if(dayOfWeek==="Sat"){
						$span.addClass("sat");
					}
					$spanMonth = $('<span>', {"class":"month", "text":d.getMonth()+1+'/'});
					$spanDate  = $('<span>', {"text":d.getDate()});
					$spanWeek  = $('<span>', {"class":"day", "text":dayOfWeek});

					if(d.getDate()===1 || d.getTime()==startDateTime){
						$(".specialContents .dateLists").append($li.append($span.append($spanMonth,$spanDate,$spanWeek)));
					}
					else{
						$(".specialContents .dateLists").append($li.append($span.append($spanDate,$spanWeek)));
					}
				}
			}
			$(".specialContents .dateLists li a:last").addClass('current');

			$(document).on('click','.dateEvent',function(){
				$idName=$(this).attr("id");
				arrJson=json.items.filter(function (element){
					if(element.datetime === $idName){
						return true;
					}
				});
					$(".specialContents-inner .text").text(arrJson[0].headline);
					$(".specialContents-inner img").attr("src",arrJson[0].image);
					$(".specialContents-inner a").attr("href",arrJson[0].url);
					$(".specialContents-inner .date").empty();
					$(".specialContents-inner .date").append(arrJson[0].date + "<span>" + arrJson[0].week + "</span>");
					$(".specialContents .dateLists li a.current").removeClass('current');
					$(this).addClass('current');
			});
		}
	});
}

function highlightDisplay(highlightList, hlstart, hlend){
	$.ajax({
		url: highlightList,
		dataType: 'json',
		async: false,
		data: { 'data' : 'data' },
		success: function(json) {
			var startDate = new Date(hlstart.substr(0,4),hlstart.substr(4,2)-1,hlstart.substr(6,2));
			var endDate   = new Date(hlend.substr(0,4),hlend.substr(4,2)-1,hlend.substr(6,2));
			var dayCount = (endDate.getTime() - startDate.getTime()) / (24*60*60*1000) ;
			var workDate = startDate;
			var jsonCount = json.length;
			for(var i = 0; i <= dayCount; i++){
				yyyymmdd = workDate.getFullYear() + '-' + ('0'+(workDate.getMonth()+1)).slice(-2) + '-' + ('0'+workDate.getDate()).slice(-2)
				dayOfWeek = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"][workDate.getDay()];
				dayTmp = '<span>'+((workDate.getDate()==1)?workDate.getMonth()+1+'/':'')+workDate.getDate()+'</span>'+'<span class="day">'+dayOfWeek+'</span>'

				$li = $('<li>');

				if(i<jsonCount){
				$a = $('<a>',{
					"class":"dateEvent",
					"id":json[i].datetime
				});
				if(i === 0) {
					$a.attr("class","dateEvent current");
				}
				$span = $('<span>',{
					"text":json[i].date
				});
				$spanDay = $('<span>',{
					"class":"day",
					"text":json[i].week
				});

				$(".specialContents .dateLists").prepend($li.append($a.append($span,$spanDay)));
				}
				else{
				$(".specialContents .dateLists").append($li.append($('<span>').append(dayTmp)));
				}
				workDate.setDate(workDate.getDate()+1);

			}
			$(document).on('click','.dateEvent',function(){
				$idName=$(this).attr("id");
				arrJson=json.filter(function (element){
					if(element.datetime === $idName){
						return true;
					}
				});
					$(".specialContents-inner .ttl").text(arrJson[0].headline);
					$(".specialContents-inner .text").text(arrJson[0].honbun);
					$(".specialContents-inner img").attr("src",arrJson[0].image);
					$(".specialContents-inner .date").empty();
					$(".specialContents-inner .date").append(arrJson[0].date + "<span>" + arrJson[0].week + "</span>");
			});
		}
	});
}
